// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"city-10"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M3 21V4.5L13 2V21H3Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M21 11H13V21H21V11Z"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M17 16V21M7 8.99805H7.00391V9.00195H7V8.99805Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M13 21H3V4.5L13 2V21ZM13 21H21V11H13V21Z","strokeWidth":"props.strokeWidth"}}]}]};

const City10Icon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'city-10',
    ref,
    icon: element,
  },
));

City10Icon.displayName = 'City10Icon';

export default City10Icon;
